import { H3, Hidden, IconList, ServiceGroupPanel, SpacerWrapper, Strong, theme } from '@ahmdigital/ui';
import { map, noop, toLower } from 'lodash/fp';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Limits, Service } from '../../types';
import CollapsedSection from '../collapsed-section';
import ExtraDetailsSection from '../extra-details-section';

const { colors } = theme;

const TopContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopContentTitle = styled(H3)`
  margin-top: 20px;
`;

type PanelProps = {
  className?: string;
  id: string;
  image?: ReactNode;
  isDisabled?: boolean;
  isSelected?: boolean;
  limits: Limits;
  onClick?: () => void;
  scale: string;
  services: Service[];
  title: string;
  withButton?: boolean;
  withExtraDetails?: boolean;
};

const Panel = ({
  className,
  id,
  image,
  isDisabled = false,
  isSelected = false,
  limits,
  onClick = noop,
  scale,
  services,
  title,
  withButton = true,
  withExtraDetails = false,
}: PanelProps): JSX.Element => {
  const inclusions = map('name', services);
  const lowercaseTitle = toLower(title);

  const topContent = () => (
    <TopContentWrapper>
      <SpacerWrapper variant="marginBottomSpacer8">
        <Hidden isBlock md lg df>
          <H3>{lowercaseTitle}</H3>
        </Hidden>
        <Hidden xs sm>
          <TopContentTitle looksLike="h4">{lowercaseTitle}</TopContentTitle>
        </Hidden>
      </SpacerWrapper>

      <Strong variant="marginBottomSpacer10">What’s included</Strong>
      <IconList
        variant="simple"
        itemSpacerSize={10}
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '({ text: string; fill: string; icon: string; } | { text: string; icon: string; fill?: undefined; })[]' is not assignable to type 'IconListItem[]'.
        items={map((inclusion) => {
          const iconProps = isSelected ? { fill: colors.green, icon: 'tick-circle' } : { icon: 'tick-circle-light' };
          return { ...iconProps, text: inclusion };
        }, inclusions)}
      />
    </TopContentWrapper>
  );

  const bottomContent = () => <CollapsedSection {...{ id, limits, scale, services }} />;
  const extraDetailsContent = () => <ExtraDetailsSection id={id} />;

  return (
    <ServiceGroupPanel
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '() => JSX.Element' is not assignable to type 'ReactNode'.
      TopContent={topContent}
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '() => JSX.Element' is not assignable to type 'ReactNode'.
      BottomContent={bottomContent}
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '(() => Element) | null' is not assignable to type 'ReactNode'.
      ExtraDetailsContent={withExtraDetails ? extraDetailsContent : null}
      buttonLabels={{ checked: 'Chosen', disabled: 'Base bundle', unchecked: 'Choose me' }}
      image={image}
      isSelected={isSelected}
      isDisabled={isDisabled}
      onClick={onClick}
      serviceGroupName={lowercaseTitle}
      className={className}
      withButton={withButton}
    />
  );
};

export default Panel;
